import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Button, Col, Divider, Dropdown, Flex, Grid, Layout, Menu, Row, Space, Form, Input, Select } from "antd";
import Avatar from "../../../../src/assets/images/user.png";
import {
    DownOutlined,
    FundProjectionScreenOutlined,
    ThunderboltOutlined,
    UserOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/app";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { doLogout, setSessionTimeOut } from "../../../store/AuthSlice";
import { WebConstant } from "../../webPages/webConstant/WebConstant";
import type { MenuProps } from 'antd';

import CommonModal from "../../../components/Modals/CommonModal";
import SVGIcon from "../../../utils/SVGIcon";
import { FormBox, InputBox } from "../../../components/AntdAddons";
import { setHasAccessCodePopup, setShowContactPopup, setHasAccessCodeStatus } from "../../../store/CommonSlice";
import { mobilePattern, postFormDataSubmit, setResetInputAnimation, Notification } from "../../../config/Global";
import ProfileArrowIcon from "../../../assets/images/icon/profile-arrow-icon.svg?react";
import { rules } from "./Rules";
import { CONSTANT } from "../../../config/Constant";
import DashboardTranslateButtons from "../../../components/GoogleTranslateElement/DashboardTranslateButtons";
const { Option } = Select;
const THINKIFIC_MEMBERSHIP = import.meta.env.VITE_THINKIFIC_MEMBERSHIP;

// import { icon } from "@fortawesome/fontawesome-svg-core";

interface SidebarViewProps {
    collapsed: boolean;
    SetCollapsed: Dispatch<SetStateAction<boolean>>;
}

/**
 * Renders the header view component for the main layout containing login and dropdown.
 *
 * @return {ReactElement} The rendered header view component.
 */
const SidebarView: React.FC<SidebarViewProps> = ({ collapsed, SetCollapsed }) => {
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();
    const userDetail = useSelector((state: RootState) => state.AUTH.userDetail)
    const contactUsModal = useSelector((state: RootState) => state.COMMON.showContactPopup)
    const hasAccessCodePopup = useSelector((state: RootState) => state.COMMON.hasAccessCodePopup)
    const logo = useSelector((state: RootState) => state.HOME.pageSettings?.banner?.banner_logo)
    const [logOutModal, setLogOutModal] = useState(false)
    // const [contactUsModal, setContactUsModal] = useState(false)
    const [isMobile, setIsMobile] = useState(false)
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const location = useLocation()


    const [form] = Form.useForm();

    const lead_source_value = Form.useWatch('c_lead_source', form); // Watch a single field


    const [searchParams, setSearchParams] = useSearchParams();
    const is_success = searchParams.get('success'); // This will return "12323"




    useEffect(() => {
        if (is_success) {
            console.log(is_success);
            Notification.success({
                placement: "top",
                message: "Inquiry Submitted Successfully."
            })
            setSearchParams('');

        }
    }, [is_success])


    console.log('contactUsModal', contactUsModal)
    const setContactUsModalShow = (value: boolean) => {
        // setHasAccessCodePopup(false);

        dispatch(setHasAccessCodePopup(false));
        dispatch(setShowContactPopup(value));
        console.log(value)
        if (!value) {
            dispatch(setHasAccessCodeStatus(false));
            setTimeout(() => {
                ((screens.xs || screens.sm) && !screens.md) && SetCollapsed(true)
                dispatch(setHasAccessCodeStatus(true));
                navigate("/trial/user-profile");
            }, 200);
        }
    }


    useEffect(() => {
        if (contactUsModal) {
            form.resetFields();
            setTimeout(() => {
                setResetInputAnimation();
            }, 1000);

        }
        else {
            setResetInputAnimation(false);
        }
        return () => {
            setResetInputAnimation(false);
        };
    }, [contactUsModal])


    console.log('hasAccessCodePopup', hasAccessCodePopup)



    // call logout function
    const showModal = () => {
        setLogOutModal(true)
    };
    const closeModal = () => {
        setLogOutModal(false)
    }
    const logOut = () => {
        sessionStorage.removeItem("welcomeData");
        dispatch(doLogout()).then(() => {
            dispatch(setSessionTimeOut(false))
            setLogOutModal(false)
            navigate("/login");
        });
    }

    const salesForceInquire = (data: any) => {

        const passurl = "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00D8V000002WMH1";
        let requestData = {
            oid: "00D8V000002WMH1",
            retURL: window.location.href + "?success=true",
            '00NRc00000hzVED': 'ECN-CustomPrice',
            first_name: data.c_first_name,
            last_name: data.c_last_name,
            email: data.c_email,
            company: data.c_company,
            city: data.c_city,
            state: data.c_state,
            // lead_source: data.c_lead_source,
            lead_source: 'Website',
            phone: data.c_phone,
            '00N8V00000ITXwh': data.c_00N8V00000ITXwh,
            // debug: "1",
            // debugEmail: "ojash.patel@iwnlenergy.com"
        }

        // requestData = requestData, ...data };
        postFormDataSubmit(passurl, requestData);
        console.log(requestData)
    }


    const siderStyle: React.CSSProperties = {
        overflow: 'auto',
        height: ((screens.sm && !screens.md) || screens.xs) ? '92dvh' : '100dvh',
        position: 'sticky',
        insetInlineStart: 0,
        top: 0,
        bottom: 0,
        scrollbarWidth: 'thin',
        scrollbarGutter: 'stable',
        maxWidth: 'auto',
        zIndex: '4'
    };


    const isFreeUser = true;
    const extraIcon = isFreeUser ? <SVGIcon icon="UserLockIcon" /> : <></>;
    const items2 = [
        {
            label: <Link to={'/trial/dashboard'}>Career Discovery Journey</Link>,
            link: "/trial/dashboard",
            key: "career-discovery",
            icon: <SVGIcon icon="CareerDiscoveryIcon" />,
            style: { paddingLeft: 'auto' },
            title: "Career Discovery Journey"
        },
        {
            label: <Link to={'/careers'}>Energy Careers Index</Link>,
            link: "/careers",
            key: "careers",
            icon: <SVGIcon icon="EnergyCarrersIcon" />,
            style: { paddingLeft: 'auto' },
            extra: extraIcon,
            disabled: isFreeUser,
            title: "Energy Careers Index"


        },
        {
            label: <Link to={'/saved-careers'}>Saved Careers</Link>,
            link: "/saved-careers",
            key: "saved-careers",
            icon: <SVGIcon icon="SavedCareersIcon" />,
            style: { paddingLeft: 'auto' },
            extra: extraIcon,
            disabled: isFreeUser,
            title: "Saved Careers"

        },
        {
            label: <Link to={'/energy-industries'}>Industry Awareness Hub</Link>,
            link: "/energy-industries",
            key: "energy-industries",
            icon: <ThunderboltOutlined style={{ color: '#95979d' }} />,
            style: { paddingLeft: 'auto' },
            extra: extraIcon,
            disabled: isFreeUser,
            title: "Industry Awareness Hub"

        },
        // <FileSearchOutlined />
        {
            label: <Link to={'#'}>Training and Pathways</Link>,
            link: "#",
            key: "training-and-pathways",
            icon: <FundProjectionScreenOutlined style={{ color: '#95979d' }} />,
            style: { paddingLeft: 'auto' },
            extra: extraIcon,
            disabled: isFreeUser,
            title: "Training and Pathways"


        },
        {
            label: <div>Resources</div>,
            key: "Resources",
            icon: <SVGIcon icon="ResourcesIcon" width={20} />,
            style: { paddingLeft: 'auto' },
            extra: extraIcon,

            // extra:extraIcon
            children: [
                // {
                //     key: 'exploration',
                //     // style: { paddingLeft: 'auto' },
                //     extra: extraIcon,
                //     label: <Link to={'/resources'}>Exploration</Link>,
                //     disabled: isFreeUser,
                // },
                {
                    key: 'energy-glossary',
                    // style: { paddingLeft: 'auto' },
                    extra: extraIcon,
                    label: <Link to={'/acronyms'} >Energy Glossary</Link>,
                    disabled: isFreeUser,
                    title: "Energy Glossary"

                },
                {
                    key: 'training-locations',
                    // style: { paddingLeft: 'auto' },
                    extra: extraIcon,
                    label: <Link to={'/locations'} >Training Locations</Link>,
                    disabled: isFreeUser,
                    title: "Training Locations"

                },
                // {
                //     key: 'training-and-credentials',
                //     // style: { paddingLeft: 'auto' },
                //     extra: extraIcon,
                //     label: <Link to={'/training-credentials'} >Training and Credentials</Link>,
                //     disabled: isFreeUser,
                // },

            ],

        },


    ];


    const items: MenuProps['items'] = [
        {
            label: <div onClick={() => { ((screens.sm && !screens.md) || screens.xs) && SetCollapsed(true); navigate("/trial/user-profile") }}>Profile</div>,
            key: "Profile",
        },
        {
            label: <div onClick={() => showModal()}>Log Out</div>,
            key: "Logout",
        },
    ];

    // const sidebarWidth = screens.xxl ? "15%" : screens.xl ? "20%" : screens.lg ? "25%" : screens.md ? '30%' : screens.sm ? "30%" : screens.xs ? "100%" : "100%"
    const sidebarWidth = screens.xxl ? "17%" : screens.xl ? "20%" : screens.lg ? "25%" : screens.md ? '30%' : (screens.sm || screens.xs) ? "100%" : "100%"
    console.log(location)
    return (
        <>
            <Layout.Sider
                breakpoint="xl"
                onBreakpoint={(broken) => {
                    setIsMobile(broken);
                }}
                // trigger={screens.xs ? null : '>'}
                width={sidebarWidth}
                // width={"20rem"}
                collapsedWidth={((screens.sm && !screens.md) || screens.xs) ? "0" : "80"}
                theme="light"
                // collapsible={window.innerWidth > 1200 ? true : false}
                collapsible={true}
                collapsed={collapsed}
                onCollapse={(value) => SetCollapsed(value)}
                style={siderStyle}

                zeroWidthTriggerStyle={{ display: 'none' }}
            // {...{collapsedWidth:'0'}}
            >
                {!((screens.sm && !screens.md) || screens.xs) && <div className="headerWrap logo-left-head">
                    <div className="app_header_left">
                        <div className="logoImg" onClick={() => navigate("/trial/dashboard")}>
                            <img className="icon" src={WebConstant?.IMAGE_URL + logo} alt="logo" />
                        </div>
                    </div>

                </div>}
                <Menu
                    selectedKeys={[location.pathname]}
                    mode="inline"
                    expandIcon={({ isOpen }) => <ProfileArrowIcon style={{ transition: 'rotate .3s', rotate: isOpen ? '90deg' : '0deg' }} />}
                    items={items2}
                    onClick={() => ((screens.sm && !screens.md) || screens.xs) && SetCollapsed(true)}
                />

                <div className="sidebar-btm-part">
                    {isFreeUser && <div className="sidebar-limited-access">
                        <h3>Limited access</h3>
                        <p>You’re currently on the free version. Get more features, insights, and tools with a subscription.</p>
                        <Link to="#" onClick={() => dispatch(setHasAccessCodePopup(true))} className="common-btn">Choose a plan</Link>
                    </div>}
                    <DashboardTranslateButtons />

                    <Space.Compact direction="vertical" style={{ width: '100%' }}>

                        <Dropdown menu={{ items }}>
                            <div>
                                <div className="profile-title-main">
                                    <SVGIcon icon="ProfileUserIcon" />
                                    <h1 className="profile-title">
                                        <div className="notranslate">{(userDetail?.name && userDetail?.name) + " " + (userDetail?.last_name && userDetail?.last_name)}</div>
                                        <span className="is-trial">{isFreeUser ? 'Free Trial' : 'Starter Access'}</span>
                                    </h1>

                                </div>
                                <div className="profile-arrow-icon">
                                    <SVGIcon icon="ProfileArrowIcon" />
                                </div>
                            </div>
                        </Dropdown>
                    </Space.Compact>
                </div>
            </Layout.Sider>

            <CommonModal
                title={"Log Out?"}
                open={logOutModal}
                onCancel={closeModal}
                // className="logOutModal"
                footer={
                    <Row gutter={[15, 15]}>
                        <Col xs={24} sm={12} md={12} lg={12}>
                            <Button key="2" htmlType="button" className="common_button green_border_common_btn" onClick={closeModal}>
                                Cancel
                            </Button>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={12}>
                            <Button
                                key="1"
                                htmlType="button"
                                className=' common_button green_border_common_btn common_fill_button'
                                onClick={() => logOut()}
                            >
                                Confirm
                            </Button>
                        </Col>
                    </Row>
                }
            >
                <Flex align={'center'} vertical>
                    <p style={{marginBottom:'auto'}}>Are you sure you want to Log Out?</p>
                    <b>
                        <div className="notranslate">&ldquo;{(userDetail?.name && userDetail?.name) + " " + (userDetail?.last_name && userDetail?.last_name)}&rdquo;</div>
                    </b>

                </Flex>
            </CommonModal>

            <CommonModal
                title={"Choose a plan"}
                open={hasAccessCodePopup}
                destroyOnHidden
                onCancel={() => dispatch(setHasAccessCodePopup(false))}
                styles={{
                    body: { display: 'none' },
                    footer: { borderTop: 'none' }
                }}
                footer={
                    <Row gutter={[15, 15]}>
                        <Col xs={24} sm={12} md={12} lg={12}>
                            <Button
                                key="1"
                                form="contactUpdateUpdate"
                                htmlType="submit"
                                onClick={() => setContactUsModalShow(false)}
                                className=' common_button green_border_common_btn '
                            >
                                I have an access code
                            </Button>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={12}>
                            <Button
                                key="1"
                                form="contactUpdateUpdate"
                                htmlType="submit"

                                // onClick={salesForceInquire}
                                onClick={() => { setContactUsModalShow(true) }}
                                className=' common_button green_border_common_btn '
                            >
                                Request a Custom Plan
                            </Button>
                        </Col>

                        <Col xs={24} sm={24} md={24} lg={24}>

                            <Button
                                key="1"
                                form="contactUpdateUpdate"
                                htmlType="submit"
                                onClick={() => window.open(CONSTANT.THINKIFIC_URL + THINKIFIC_MEMBERSHIP, '_blank', 'noopener,noreferrer')}
                                className=' common_button green_border_common_btn common_fill_button'
                            >
                                Begin Career Discovery Journey
                            </Button>
                        </Col>
                    </Row>
                }
            ></CommonModal>

            <CommonModal
                title={"Request a Custom Plan"}
                open={contactUsModal}
                destroyOnHidden
                // width={'40vw'}
                width={{
                    xs: '90%',
                    sm: '80%',
                    md: '70%',
                    lg: '60%',
                    xl: '50%',
                    xxl: '40%',
                }}
                onCancel={() => dispatch(setShowContactPopup(false))}
                footer={
                    <Row gutter={[15, 15]}>
                        <Col xs={24} sm={24} md={24} lg={24}>
                            <Button
                                key="1"
                                form="contactUpdateUpdate"
                                htmlType="submit"
                                // onClick={salesForceInquire}
                                className=' common_button green_border_common_btn common_fill_button'
                            >
                                Send Request
                            </Button>
                        </Col>
                    </Row>
                }
            >



                <FormBox
                    layout="vertical"
                    autoComplete="off"
                    form={form}
                    id="contactUpdateUpdate"
                    onFinish={salesForceInquire}
                    // onValuesChange={salesForceInquire}
                    className=" commanDrawer"
                >
                    <Row gutter={[0, 24]}>
                        <Col sm={12} xs={24} md={12} xl={12} xxl={12}>
                            <InputBox.Text
                                name="c_first_name"
                                label={<>First Name <em>*</em></>}
                                placeholder=''
                                rules={rules.first_name()}
                                className="ecn-input profile-input"
                            />
                        </Col>
                        <Col sm={12} xs={24} md={12} xl={12} xxl={12}>
                            <InputBox.Text
                                name="c_last_name"
                                label={<>Last Name <em>*</em></>}
                                placeholder=''
                                rules={rules.last_name()}
                                className="ecn-input profile-input"
                            />
                        </Col>
                        <Col sm={12} xs={24} md={12} xl={12} xxl={12}>
                            <InputBox.Text
                                name="c_email"
                                label={<>Email <em>*</em></>}
                                placeholder=''
                                rules={rules.email()}
                                className="ecn-input profile-input"
                            />
                        </Col>
                        <Col sm={12} xs={24} md={12} xl={12} xxl={12}>
                            <InputBox.Text
                                name="c_company"
                                label={<>Company <em>*</em></>}
                                placeholder=''
                                rules={rules.company()}
                                className="ecn-input profile-input"
                            />
                        </Col>
                        <Col sm={12} xs={24} md={12} xl={12} xxl={12}>
                            <InputBox.Text
                                name="c_city"
                                label={<>City <em>*</em></>}
                                placeholder=''
                                rules={rules.city()}
                                className="ecn-input profile-input"
                            />
                        </Col>
                        <Col sm={12} xs={24} md={12} xl={12} xxl={12}>
                            <InputBox.Text
                                name="c_state"
                                label={<>State/Province <em>*</em></>}
                                placeholder=''
                                rules={rules.state()}
                                className="ecn-input profile-input"
                            />
                        </Col>
                        {/* <Col sm={24} xs={24} md={24} xl={24} xxl={24}>
                            <InputBox.Select
                                label={<>Lead Source?</>}
                                placeholder=''
                                className={"ecn-input profile-input " + (lead_source_value == null ? '' : 'active')}
                                name="c_lead_source"

                                // rules={rules.lead_source()}
                                options={{
                                    list: [
                                        { id: "", name: "--None--" },
                                        { id: "ACP Conference", name: "ACP Conference" },
                                        { id: "IPF Conference", name: "IPF Conference" },
                                        { id: "ACORE (American Council on Renewable Energy)", name: "ACORE (American Council on Renewable Energy)" },
                                        { id: "Conference", name: "Conference" },
                                        { id: "Word of mouth", name: "Word of mouth" },
                                        { id: "External Referral", name: "External Referral" },
                                        { id: "Website", name: "Website" },
                                        { id: "Social", name: "Social" },
                                        { id: "Advertisement", name: "Advertisement" },
                                        { id: "Employee Referral", name: "Employee Referral" },
                                        { id: "On Site", name: "On Site" },
                                        { id: "ACP NOLA", name: "ACP NOLA" },
                                    ],
                                    valueKey: "id",
                                    textKey: "name",
                                }}
                            />
                        </Col> */}
                        <Col sm={12} xs={24} md={12} xl={12} xxl={12}>
                            <InputBox.Text
                                name="c_phone"
                                label={<>Phone <em>*</em></>}
                                placeholder=''
                                rules={rules.mobile()}
                                maxLength={20}
                                onChange={(e: any) => {
                                    if (e.target.value.length > 0) {
                                        form.setFieldsValue({
                                            c_phone: mobilePattern(e.target.value),
                                        });
                                    }
                                }}
                                className="ecn-input profile-input"
                            />
                        </Col>
                        <Col sm={12} xs={24} md={12} xl={12} xxl={12}>
                            <InputBox.Text
                                name="c_00N8V00000ITXwh"
                                label={<>LinkedIn </>}
                                placeholder=''
                                // rules={rules.linkedIn()}
                                className="ecn-input profile-input"
                            />
                        </Col>



                    </Row>

                </FormBox>
            </CommonModal >
        </>



    );
}

export default SidebarView;
